module.exports = __webpack_public_path__ + "static/woman-hiking-and-smiling.b66887e9.webp";